import { render, staticRenderFns } from "./GPickerCreate.vue?vue&type=template&id=1818b6a4&scoped=true&"
import script from "./GPickerCreate.vue?vue&type=script&lang=js&"
export * from "./GPickerCreate.vue?vue&type=script&lang=js&"
import style0 from "./GPickerCreate.vue?vue&type=style&index=0&id=1818b6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818b6a4",
  null
  
)

export default component.exports